import _ from 'lodash'
import store from '../store/index'

class NotificationService {

    static info (message, options = null) {
        const snotify = _.get(store, ['$app', '$snotify'], null)
        snotify.info(message, options)
    }

    static success (message, options = null) {
        const snotify = _.get(store, ['$app', '$snotify'], null)
        snotify.success(message, options)
    }

    static warning (message, options = null) {
        const snotify = _.get(store, ['$app', '$snotify'], null)
        snotify.warning(message, options)
    }

    static error (message, options = null) {
        const snotify = _.get(store, ['$app', '$snotify'], null)
        snotify.error(message, options)
    }
}

export default NotificationService